import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";

import { getPatientProfile } from "@/redux/actions/auth";

import { updateMemberProfile } from "../queryFunctions/updateMemberProfile";

export function useUpdateMemberProfile() {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: updateMemberProfile,
    onSuccess: () => {
      dispatch(getPatientProfile(true));
      // use when more memberProfile react-query refactors happen
      // queryClient.invalidateQueries({ queryKey: memberProfileKeys.base });
    },
  });
}
